// User
export const HOME_PAGE_PATH = "/home";
export const PROFILE_PAGE_PATH = "/profile";
export const SETTINGS_PAGE_PATH = "/settings";
export const DASHBOARD_PAGE_PATH = "/dashboard";
export const NOTIFICATIONS_PAGE_PATH = "/notifications";

// Commons
export const ZONES_PAGE_PATH = "/zones";
export const VENDORS_PAGE_PATH = "/vendors";
export const AGENCIES_PAGE_PATH = "/agencies";
export const COMPANIES_PAGE_PATH = "/companies";
export const OPERATORS_PAGE_PATH = "/operators";

// Accounts
export const ALL_SIMS_PAGE_PATH = "/accounts/all";
export const FLEETS_SIMS_PAGE_PATH = "/accounts/fleet";
export const AGENTS_SIMS_PAGE_PATH = "/accounts/agent";
export const MASTERS_SIMS_PAGE_PATH = "/accounts/master";
export const RESOURCES_SIMS_PAGE_PATH = "/accounts/resource";
export const COLLECTORS_SIMS_PAGE_PATH = "/accounts/collector";

// Reports
export const MOVEMENTS_PAGE_PATH = "/reports/movements";
export const TRANSACTIONS_PAGE_PATH = "/reports/transactions";

// Users
export const AGENTS_PAGE_PATH = "/users/agents";
export const ADMINS_PAGE_PATH = "/users/admins";
export const MANAGERS_PAGE_PATH = "/users/managers";
export const OVERSEERS_PAGE_PATH = "/users/overseers";
export const RESOURCES_PAGE_PATH = "/users/resources";
export const COLLECTORS_PAGE_PATH = "/users/collectors";
export const SUPERVISORS_PAGE_PATH = "/users/supervisors";
export const ACCOUNTANTS_PAGE_PATH = "/users/accountants";

// Operations
export const OPERATIONS_FLEETS_PAGE_PATH = "/operations/fleets";
export const OPERATION_AFFORDS_PAGE_PATH = "/operations/affords";
export const OPERATIONS_TRANSFERS_PAGE_PATH = "/operations/transfers";
export const OPERATIONS_CLEARANCES_PAGE_PATH = "/operations/clearances";
export const OPERATIONS_ANONYMOUS_FLEETS_PAGE_PATH = "/operations/anonymous-fleets";

// Recoveries
export const RECOVERIES_CASH_PAGE_PATH = "/recoveries/cash";
export const RECOVERIES_FLEETS_PAGE_PATH = "/recoveries/fleets";

// Requests
export const REQUESTS_FLEETS_PAGE_PATH = "/requests/fleets";
export const REQUESTS_CLEARANCES_PAGE_PATH = "/requests/clearances";

// Checkout
export const CHECKOUT_HANDING_OVER_PAGE_PATH = "/checkout/handing-over";
export const CHECKOUT_INTERNAL_OUTLAYS_PAGE_PATH = "/checkout/internal-outlays";
export const CHECKOUT_EXTERNAL_OUTLAYS_PAGE_PATH = "/checkout/external-outlays";
export const CHECKOUT_INTERNAL_PAYMENTS_PAGE_PATH = "/checkout/internal-payments";
export const CHECKOUT_EXTERNAL_PAYMENTS_PAGE_PATH = "/checkout/external-payments";

